module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/1_d36dc7c2be323d59b36705b03705651a.png";